import { ComponentType } from 'react';
import { withStandardBaseCssClass } from '@adobe/aem-core-components-react-spa';

type ContainerType = 'tabs';

const containers = {
  tabs: {
    defaultBaseClass: 'cmp-tabs',
    getAttributes: (cqPath: string) => ({
      'data-cmp-is': 'tabs',
      'data-panelcontainer': 'tabs',
      'data-cq-data-path': cqPath,
    }),
  },
};

const withAttributes = <T extends { extraAttributes?: Record<string, string>; cqPath: string; baseCssClass?: string }>(
  Comp: ComponentType<T>,
  type: ContainerType,
) => {
  return withStandardBaseCssClass((props: T) => {
    const { cqPath } = props;

    const attributes = containers[type].getAttributes(cqPath);

    return <Comp {...props} extraAttributes={type === 'tabs' ? attributes : {}} />;
  }, containers[type].defaultBaseClass);
};

export default withAttributes;
